<div>
  <ng-container *ngIf="reasons$ | async as reason; else loading">
    <app-alert
      style="margin-bottom: 40px"
      class="flex-col-container mt-32"
      type="warning"
      icon="warning_amber"
      lineHeight="lh-1"
      [message]="'MODAL_CANCEL_CONTRACT.ALERT' | translate">
    </app-alert>

    <p class="my-10">{{ 'MODAL_CANCEL_CONTRACT.STATEMENT' | translate}}</p>

    <div class="p-16 flex-row-container items-center b-0-5 rounded">
      <img
        class="mr-8"
        [src]="'/assets/svg/contract-' + contract?.type?.toLowerCase() + '.svg'"
        [alt]="'contract-' + contract?.type?.toLowerCase()" />
      <div class="flex-col-container start flex-1 ml-4">
        <span class="fw-500">{{ 'MODAL_CANCEL_CONTRACT.ACCOUNT_NUMBER' | translate}}</span>
        <span>{{contract?.contract_number}}</span>
      </div>
      <app-read-only
        [descColor]="contract?.state === STATUS.ACTIVE ? 'success' : 'warning'"
        [applyBorderBottom]="false"
        [value]="contract?.state"></app-read-only>
    </div>

    <form class="w-95 mt-10 m-auto" [formGroup]="cancelContractForm">
      <mat-form-field class="w-all mt-15 px-8">
        <mat-label>{{ 'MODAL_CANCEL_CONTRACT.SELECT' | translate}}</mat-label>
        <mat-select class="select-padding" formControlName="reason">
          <mat-option *ngFor="let item of reason" [value]="item"> {{ item.description }} </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-template #loading>
    <app-skeleton-container [errorMessage]="this.errorMessage" [errorThrown]="this.errorThrown">
      <div class="flex-row-container gap-16">
        <div class="flex-col-container flex-1">
          <app-skeleton-text height="64px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="32px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="72px" width="100%" [count]="1"></app-skeleton-text>
          <app-skeleton-text className="mt-16" height="32px" width="100%" [count]="1"></app-skeleton-text>
        </div>
      </div>
    </app-skeleton-container>
  </ng-template>
</div>
